// extracted by mini-css-extract-plugin
module.exports = {"container":"BulletBox_container__RlC4f","background__grey":"BulletBox_background__grey__yQ4XN","background__white":"BulletBox_background__white__TPGkj"};